import * as React from 'react'

import { useKPIList } from './hooks'
import { CButton, CCardBody, CCol, CRow } from '@coreui/react-pro'
import { path } from '../../../libs'
import { Divider, Table, Tag } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { Income } from './types'
import moment from 'moment'
import CIcon from '@coreui/icons-react'
import { cilZoom } from '@coreui/icons'
import { cilArrowLeft } from '@coreui/icons/js/free/cil-arrow-left'

export const KPIView = () => {
  const { incomeByDay, loading } = useKPIList()

  const columns: ColumnsType<Income> = [
    {
      title: 'Day',
      dataIndex: 'transactionToDay',
      key: 'transactionToDay',
      defaultSortOrder: 'descend',
      sorter: (a, b) =>
        // @ts-ignore
        new Date(
          moment(a.transactionToDay, 'YYYY-MM-DD, h:mm:ss').format('LLL'),
        ) -
        // @ts-ignore
        new Date(
          moment(b.transactionToDay, 'YYYY-MM-DD, h:mm:ss').format('LLL'),
        ),
    },
    {
      title: 'Deposit (USD)',
      dataIndex: 'totalDeposit',
      key: 'totalDeposit',
      sorter: (a, b) => parseInt(a.totalDeposit) - parseInt(b.totalDeposit),
      render: (item) => <>{parseFloat(item).toFixed(2)}</>,
    },
    {
      title: 'Withdrawal (USD)',
      dataIndex: 'totalWithdrawal',
      key: 'totalWithdrawal',
      sorter: (a, b) =>
        parseInt(a.totalWithdrawal) - parseInt(b.totalWithdrawal),
      render: (item) => <>{parseFloat(item).toFixed(2)}</>,
    },
    {
      title: 'Partner balance',
      render: (item: Income) => {
        return (
          <Tag
            color={Number(item.partnerBalance) >= 0 ? 'success' : 'error'}
          >{`${parseFloat(item.partnerBalance).toFixed(2)} (${
            item.percentPartnerBalance
          } %)`}</Tag>
        )
      },
    },
    {
      title: 'Income (USD)',
      dataIndex: 'balance',
      key: 'balance',
      sorter: (a, b) => parseInt(a.balance) - parseInt(b.balance),
      render: (item) => {
        if (item > 0) {
          return (
            <Tag color="success">
              <strong>{parseFloat(item).toFixed(2)}</strong>
            </Tag>
          )
        } else {
          return (
            <Tag color="error">
              <strong>{parseFloat(item).toFixed(2)}</strong>
            </Tag>
          )
        }
      },
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 100,
      render: (item) => {
        return (
          <>
            <CButton
              color="secondary"
              className="me-2"
              title="View"
              href={
                path.kpi.transactions() +
                '?updatedAt=' +
                moment(item.transactionToDay, 'YYYY-MM-DD, h:mm:ss').format(
                  'YYYY-MM-DD',
                )
              }
            >
              <CIcon icon={cilZoom} />
            </CButton>
          </>
        )
      },
    },
  ]

  const csvContent = incomeByDay
    .map((item: { [s: string]: unknown } | ArrayLike<unknown>) =>
      Object.values(item).join(','),
    )
    .join('\n')

  const csvCode =
    'data:text/csv;charset=utf-8,SEP=,%0A' + encodeURIComponent(csvContent)

  return (
    <CCardBody>
      <CRow>
        <CCol xs={10}>
          <CButton
            color="primary"
            className="mb-2"
            href={csvCode}
            download="coreui-table-data.csv"
            target="_blank"
          >
            Download current items (.csv)
          </CButton>
        </CCol>
        <CCol className=" d-flex align-items-baseline justify-content-end">
          <CButton
            color="secondary"
            className="me-2"
            title={'<- Back'}
            href={path.kpi.entry()}
          >
            <CIcon icon={cilArrowLeft} /> {'Back'}
          </CButton>
        </CCol>
      </CRow>

      <Divider />
      <Table
        dataSource={incomeByDay}
        columns={columns}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="transactionByMonth"
        pagination={{ position: [], pageSize: 50 }}
      ></Table>
    </CCardBody>
  )
}
